import req from "../../../services/psikotest/request";

class CfitQuestionary {
  async list() {
    try {
      const res = await req.get("/api/psikotest_system/cfit_questionary/");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async create(data: TPSCfitQuestionary) {
    try {
      const res = await req.post("/api/psikotest_system/cfit_questionary/", data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async get(id: string) {
    try {
      const res = await req.get("/api/psikotest_system/cfit_questionary/" + id);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async update(data: TPSCfitQuestionary) {
    try {
      const res = await req.put("/api/psikotest_system/cfit_questionary/" + data.id, data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async delete(data: TPSCfitQuestionary) {
    try {
      const res = await req.delete("/api/psikotest_system/cfit_questionary/", { data });
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default CfitQuestionary;
